module.exports = __webpack_public_path__ + "static/media/shape2.8cde08f5.png";